import type {PermissionsRecordType} from '../permissions';

export const newVehiclePermissions = {
  newVehicleCatalogueRead: {
    actionId: 'READ',
    resourceId: 'NEW_VEHICLE_CATALOGUE',
    scopes: [],
  },
  newVehicleCatalogueWrite: {
    actionId: 'WRITE',
    resourceId: 'NEW_VEHICLE_CATALOGUE',
    scopes: [],
  },
  newVehicleCataloguePublish: {
    actionId: 'PUBLISH',
    resourceId: 'NEW_VEHICLE_CATALOGUE',
    scopes: [],
  },
  newVehicleCatalogueViewCost: {
    fieldId: 'COST',
    resourceId: 'NEW_VEHICLE_CATALOGUE',
    scopes: [],
  },
  newVehicleConfigurationRead: {
    actionId: 'READ',
    resourceId: 'NEW_VEHICLE_CONFIGURATION',
    scopes: [],
  },
  newVehicleConfigurationWrite: {
    actionId: 'WRITE',
    resourceId: 'NEW_VEHICLE_CONFIGURATION',
    scopes: [],
  },
  newVehicleConfigurationOrder: {
    actionId: 'ORDER',
    resourceId: 'NEW_VEHICLE_CONFIGURATION',
    scopes: [],
  },
  newVehicleConfigurationRegisterExternal: {
    actionId: 'REGISTER_EXTERNAL',
    resourceId: 'NEW_VEHICLE_CONFIGURATION',
    scopes: [],
  },
  newVehicleConfigurationViewCost: {
    actionId: 'VIEW_COST',
    resourceId: 'NEW_VEHICLE_CONFIGURATION',
    scopes: [],
  },
  newVehicleConfigurationCustomFields: {
    actionId: 'CUSTOM_FIELDS_PAYLOAD_UPDATE',
    resourceId: 'NEW_VEHICLE_CONFIGURATION',
    scopes: [],
  },
  newVehicleOrderRead: {
    actionId: 'READ',
    resourceId: 'NEW_VEHICLE_ORDER',
    scopes: [],
  },
  newVehicleOrderUpdateStatus: {
    actionId: 'UPDATE_STATUS',
    resourceId: 'NEW_VEHICLE_ORDER',
    scopes: [],
  },
  newVehicleOrderCancel: {
    actionId: 'CANCEL',
    resourceId: 'NEW_VEHICLE_ORDER',
    scopes: [],
  },
  newVehicleOrderMarkHandedOver: {
    actionId: 'MARK_HANDED_OVER',
    resourceId: 'NEW_VEHICLE_ORDER',
    scopes: [],
  },
  newVehicleOrderChangeFactoryReference: {
    actionId: 'CHANGE_FACTORY_REFERENCE',
    resourceId: 'NEW_VEHICLE_ORDER',
    scopes: [],
  },
} satisfies PermissionsRecordType;
